import { Platform } from 'react-native';

/** Matches `sm` in `packages/smoothie/src/tamagui.config.ts` */
export const SM_MEDIA_MIN_WIDTH = 770;

/** Native phone-only splash column (iOS/Android); web & iPad use wider layouts. */
export const NATIVE_PHONE_SPLASH_COLUMN_MAX_WIDTH = 356;

/** Default splash inner column when not using {@link NATIVE_PHONE_SPLASH_COLUMN_MAX_WIDTH}. */
export const DEFAULT_SPLASH_INNER_COLUMN_MAX_WIDTH = 380;

/** Extra space above the cash-back row on native iPad (hero sits close via overlapping art). */
export const IPAD_EXTRA_MARGIN_ABOVE_CASHBACK_SECTION = 48;

/** iPad / iPadOS only — not iPhone (any orientation). */
export const getIsIosIPad = (): boolean => {
    if (Platform.OS !== 'ios') {
        return false;
    }
    return typeof Platform.isPad === 'boolean' && Platform.isPad;
};
